
import {useState,useEffect} from 'react'
import {useNavigate , useLocation} from "react-router-dom";
import SendData from "./SendData"

function WindowSetting ({socket}){
  const location = useLocation ();
  const [name,setName] = useState (/*location.state.name*/);
  const navigate = useNavigate ();

  const [calibr,setCalibr]=useState (location.state.calibr+'');
  const [wind_close,setWind_close]=useState (location.state.wind_close+'');
  const [time_close,setTime_close]=useState (location.state.time_close+'');

  useEffect (()=>{
  return () =>{
    socket.off ('message');
  };
},[socket]);

  return (
    <div style={style.container}>
      <div style={style.content}>
        <h2 style={style.text}>
          تایم باز شدن کامل پنجره
        </h2>
        <input style={style.input}
        type="tel"
        placeholder = ""
        value={calibr}
        onChange = {(e)=>{setCalibr (e.target.value)}}/>
    </div>


    <div style={style.content}>
      <h2 style={style.text}>
        سرعت باد برای بستن پنجره
      </h2>
      <input style={style.input}
      type="tel"
      placeholder = ""
      value={wind_close}
      onChange = {(e)=>{setWind_close (e.target.value)}}/>
  </div>

  <div style={style.content}>
    <h2 style={style.text}>
      مدت بسته بودن پنجره در باد زیاد
    </h2>
    <input style={style.input}
    type="tel"
    placeholder = ""
    value={time_close}
    onChange = {(e)=>{setTime_close (e.target.value)}}/>
  </div>

  <button className="btn"
      onClick ={()=>{
      socket.off ('message');
      socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="SAVE_MENU_WINDOW" && JSON.parse(data).data==true)
            {
              window.alert ('اطلاعات با موفقیت ذخیره شد');
              socket.off ('message');
              navigate (-1);
            }
        });

        SendData (socket,'data',{
          "event":"set_menu_window",
          "data":{
            "calibr":calibr,
            "wind_close":wind_close,
            "time_close":time_close,
          }
        });
      }}>
       تایید
    </button>
    </div>
  );


}
const style={
  container:{
    width:"90%",
    minHeight:"100vh",
//    display:"flex",
    alignItems:"center",
    padding:10,

//    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
     maxWidth:820,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10,
    padding:10,
    backgroundColor:"#00afff",
    borderRadius:8
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:20,
    borderRadius:8,
    textAlign:"center"
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:820,
    padding:4,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
    padding:0,
    margin:10,
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default WindowSetting;
